import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import React, { Suspense } from 'react';
import { AuthContextType } from '../contexts/AuthContext';
import { isDevelopmentModeEnabled } from '../utils/envUtils';

const devtoolsConfig = { position: 'bottom-right' as const };

const LazyDevtools = React.lazy(async () => {
  const { TanStackDevtools } = await import('@tanstack/react-devtools');
  const { TanStackRouterDevtoolsPanel } = await import(
    '@tanstack/react-router-devtools'
  );
  return {
    default: () => (
      <TanStackDevtools
        config={devtoolsConfig}
        plugins={[
          { name: 'Tanstack Router', render: <TanStackRouterDevtoolsPanel /> },
        ]}
      />
    ),
  };
});

export interface RouterContext {
  auth: AuthContextType;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const isDevMode = isDevelopmentModeEnabled();
  return (
    <>
      <Outlet />
      {isDevMode && (
        <Suspense fallback={null}>
          <LazyDevtools />
        </Suspense>
      )}
    </>
  );
}
